module.exports = __webpack_public_path__ + "67e0f805f7118a896bbb57d1f4b9c376.png";